import TagManager from "react-gtm-module";
import { useCallback, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchData, logout } from "./redux/actions";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import Preloader from "./helper/Preloader";
import ServerDown from "./helper/ServerDown";
import AppRoutes from "./AppRoutes";
import { getData, getError, getLoadingState } from "./redux/selectors";
import "./external_css/style.css";

function App() {
  const dispatch = useDispatch();
  const data = useSelector(getData("landing"));
  const error = useSelector(getError("landing"));
  const loading = useSelector(getLoadingState("landing"));
  const region = useSelector((state) => state?.region?.region);

  // auto clearing the local storage - start
  useEffect(() => {
    const fetchDataAsync = () => {
      //if (!data)
      {
        dispatch(fetchData("landing", "pages?path=/&region=" + region));
      }
    };
    fetchDataAsync();
  }, [region]); //[region,data, dispatch]);

  const setExpiry = () => {
    const expiry = Date.now() + 60 * 45 * 1000;
    localStorage.setItem("expiry", expiry);
  };

  const clearLocalStorage = useCallback(() => {
    const expiry = Number(localStorage.getItem("expiry"));
    if (expiry && Date.now() > expiry) {
      console.log("Clearing localStorage...");
      dispatch(logout());
      localStorage.clear();
    }
  }, [dispatch]);

  useEffect(() => {
    TagManager.initialize({ gtmId: "GTM-NWFKH6B9" });
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("expiry")) {
      setExpiry();
    }

    const interval = setInterval(() => {
      clearLocalStorage();
    }, 1000);

    return () => clearInterval(interval);
  }, [clearLocalStorage]);

  if (loading) {
    //|| !data
    return <Preloader />;
  }

  if (error) {
    return <ServerDown />;
  }

  if (data?.en?.sections) {
    return (
      <BrowserRouter>
        <RouteScrollToTop />
        <PhosphorIconInit />
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          className="z-[9999]"
        />
        <AppRoutes />
      </BrowserRouter>
    );
  }

  // return <div>No Data Available</div>;
}
export default App;
